import { authEndpoints } from '@sentinel/web-core';
import { communicationEndpoints } from './operations/communications';
import { configurationEndpoints } from './platform/configuration';
import { connectivityEndpoints } from './field/connectivity';
import { droneEndpoints } from './field/drones';
import { mappingEndpoints } from './operations/mapping';
import { markerEndpoints } from './operations/markers';
import { roleEndpoints, userEndpoints } from './platform/identity';
import { missionEndpoints } from './operations/missions';
import { notificationEndpoints } from './platform/notifications';
import { personnelEndpoints } from './operations/personnel';
import { placeEndpoints } from './operations/places';
import { platformEndpoints } from './platform/platform';
import { privacyEndpoints } from './platform/privacy';
import { reportEndpoints } from './operations/reports';
import { sensorEndpoints } from './field/sensors';
import { teamEndpoints } from './operations/teams';
import { trackingEndpoints } from './operations/tracking';
import { weatherEndpoints } from './field/weather';

/** Typed endpoints, one group per module; every function maps to a contract of `@sentinel/shared`. */
export const endpoints = {
  auth: authEndpoints,
  missions: missionEndpoints,
  roles: roleEndpoints,
  users: userEndpoints,
  configuration: configurationEndpoints,
  platform: platformEndpoints,
  drones: droneEndpoints,
  privacy: privacyEndpoints,
  personnel: personnelEndpoints,
  notifications: notificationEndpoints,
  mapping: mappingEndpoints,
  markers: markerEndpoints,
  weather: weatherEndpoints,
  communications: communicationEndpoints,
  teams: teamEndpoints,
  tracking: trackingEndpoints,
  reports: reportEndpoints,
  connectivity: connectivityEndpoints,
  sensors: sensorEndpoints,
  places: placeEndpoints,
};

export type {
  AuditEntryRow,
  OrganizationModuleRow,
  OrganizationProfile,
  StatusDefinitionRow,
} from './platform/configuration';
export type { PersonRow } from './operations/missions';
export type { OrganizationSummary } from './platform/platform';
